import Vue from 'vue';
// import Vuetify, {
// } from 'vuetify/lib';

// import { Ripple } from 'vuetify/lib/directives';

// Vue.use(Vuetify, {
//   directives: {
//     Ripple,
//   },
// });

// import 'vuetify/dist/vuetify.css';
import App from './App.vue';
import store from './store/store';
// import './registerServiceWorker';

// import 'vuetify/src/stylus/app.styl';
// Import App Custom Styles
// eslint-disable-next-line no-unused-vars
import AppStyles from './assets/less/app.less';

// Vue.use(Vuetify);

Vue.config.productionTip = false;

Vue.prototype.$bus = new Vue();

new Vue({
  store,
  render: h => h(App),
}).$mount('#app');
